module.exports = __webpack_public_path__ + "images/landing/video-previews/house_preview_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/house_preview_2x.jpg
// module id = bAkP
// module chunks = 1